import moment, { LongDateFormatKey } from 'moment';
import 'moment/locale/nb';
import 'moment/locale/da';
import 'moment/locale/sv';
import 'moment/locale/es';
import 'moment/locale/ar';
import { UserLanguageService } from '../services';

const DateTimeParser = {
  toLocaleDateString(date: string | Date | null): string {
    if (date === null) {
      return '';
    }

    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return moment(dateObj).locale(this.getCurrentCultureCode()).format('L');
  },

  toLocaleTimeString(jsonFormatDateString: string): string {
    const date = new Date(jsonFormatDateString);
    return moment(date).locale(this.getCurrentCultureCode()).format('LT');
  },

  toLocaleDateTimeString(jsonFormatDateString: string): string {
    return (
      this.toLocaleDateString(jsonFormatDateString) +
      ' ' +
      this.toLocaleTimeString(jsonFormatDateString)
    );
  },

  toDateObject(value: any) {
    const localeFormat = moment.localeData(this.getCurrentCultureCode()).longDateFormat('L');

    return new Date(
      moment(value, localeFormat).weekYear(),
      moment(value, localeFormat).month(),
      moment(value, localeFormat).date()
    );
  },

  toValueOf(date: string) {
    const localeFormat = moment.localeData(this.getCurrentCultureCode()).longDateFormat('L');
    return moment(date, localeFormat).valueOf();
  },

  toDateFormat(date: string, format: string): string {
    const localeFormat = moment.localeData(this.getCurrentCultureCode()).longDateFormat('L');
    return moment(date, localeFormat).locale('en').format(format);
  },

  addDays(daysNumber: number) {
    moment.locale(this.getCurrentCultureCode());
    return moment().add(daysNumber, 'days').format('L');
  },

  add(startDate: string, amount: number, unit: any, format: moment.LongDateFormatKey = 'L') {
    const localeFormat = moment.localeData(this.getCurrentCultureCode()).longDateFormat(format);

    return moment(startDate, localeFormat).add(amount, unit).format(format);
  },

  isValidFormat(date: string, format: LongDateFormatKey): boolean {
    const localeFormat = moment.localeData(this.getCurrentCultureCode()).longDateFormat(format);

    if (moment(date, localeFormat, true).isValid()) {
      return true;
    }

    return false;
  },

  isAfter(date: string) {
    const localeFormat = moment.localeData(this.getCurrentCultureCode()).longDateFormat('L');

    if (moment(date, localeFormat).isAfter(moment(), 'day')) {
      return true;
    }

    return false;
  },

  getFormat(format: moment.LongDateFormatKey): any {
    moment.locale(this.getCurrentCultureCode());

    const localeData = moment.localeData();

    return localeData.longDateFormat(format);
  },

  subtract(startDate: string, amount: number, unit: any) {
    const localeFormat = moment.localeData(this.getCurrentCultureCode()).longDateFormat('L');

    return moment(startDate, localeFormat).subtract(amount, unit);
  },

  getCurrentCultureCode(): string {
    return UserLanguageService.getLanguageCode();
  },
};
export default DateTimeParser;
